import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  content
`

export const getProductsQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getProducts(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getProducts(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






